export default __webpack_public_path__ + "static/media/Thought Gear Propagate.448e5f40.png";